import React, { useEffect } from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import { useRouter } from './components';
import { StoreProvider } from './store';
import { ViewPage } from './cms/pages/viewPage/viewPage';
import { EditPage } from './cms/pages/editPage/editPage';
import { TopHeader } from './layout/topHeader/topHeader';
// import { Footer } from './layout/footer/footer';
import { BottomDock } from './layout/bottomDock/bottomDock';
import { MenuLoader } from './layout/menuLoader';
// import { BlogView } from './site/blog/blogView';
import { AppVersionPage } from './components';
import { MediaQueryStatus } from './components';
import { CommonVideoPopup } from "./layout/popup/commonVideoPopup";
import { HelmetProvider } from 'react-helmet-async';
//import { useScrollPosition } from '@n8tb1t/use-scroll-position';
import { AppRouteChanged } from './AppRouteChanged';
import AOS from 'aos';

// Admins
import { AdminsLayout } from 'layout/AdminsLayout/adminsLayout';
// import AdminProtectedRoute from 'components/requireRole';

import { DashboardLayout } from 'components/Dashboard';
import { ProfileView } from 'components/Profile/ProfileView';
import { DashboardProtectedRoute, ProfileProtectedRoute, MemberProtectedRoute, AdminProtectedRoute } from 'components/ProtectedRoutes';

// import MemberLayout from './layout/memberLayout';
// import DashboardNoAuthLayoutRoute from 'layout/dashboardNoAuthLayout';
// import PermissionCheckFirst from 'layout/permissionCheckFirst';

// For AUTH
import { ProvideAuth } from 'auth';
import { SiteAuthLayout } from 'site/siteAuth/index';

//For ECM
// import { ProductView } from './site/ecm/product/productView';
// import { OrderDetails } from './site/ecm/orderDetails/orderDetails';
// import env from './env';
// import { useStore } from './store';

import { ProtectedRoute } from './components/ProtectedRoute';
import { UnifiedLogin } from 'components/UnifiedLogin/view';

function AppLayout(props) {
  const { pathname } = useRouter();
  // const users = useUsers();
  // console.log("USERS", users);
  
  //For ECM
  //const storeContext = useRef(useStore());
  
  //const [scrolled, setScrolled] = useState(false)
  //const path = usePath();
  //const routeResult = useRoutes(routes);

  // const parallax = useParallax();
  // //console.log(path, routeResult);
  // const routeChanged = (path) => {
  //   //console.log(path);
  //   parallax.reset();
  // }

  // useScrollPosition(({ prevPos, currPos }) => {
  //   //console.log(currPos.x)
  //   //console.log(currPos.y);
  //   if (currPos.y > 90) {
  //     document.querySelector('body').classList.add('scrolled')
  //   } else {
  //     document.querySelector('body').classList.remove('scrolled')
  //   }
  //   //setScrolled(currPos.y > 90)
  // }, [], null, true)

  //const pageChanged = useCallback(path => routeChanged(path), [])
  //useLocationChange((path) => { routeChanged(path, history)})
  //useLocationChange(path => routeChanged(path))
  
  //const pathFiltered = (pathname || '').toLocaleLowerCase();
  let specialClassName = '';
//  if (pathFiltered.indexOf('/digital-sensor') >= 0) specialClassName = 'digital-sensor-page';
//  else if (pathFiltered === '/brilliance') specialClassName = 'brilliance-page';

useEffect(()=>{
  AOS.init({
    duration : 1200
    //delay:400,
    //once:true
  });

  // For ECM
  // fetch(env.apiBase + "/api/cart/getcart/" + env.getDevCartId())
  //   .then(res => res.json())
  //   .then(res => {
  //       const data = res;
  //       if(data){
  //         storeContext.current.dispatch({type:'SET_STATE', payload : {cartInfo : data.cartInfo.totalQuantity === 0 ? 0 : (data.cartInfo.totalQuantity)-1}});
  //       }
  //   })
  //   .catch(error =>{
  //     storeContext.current.dispatch({type:'SET_STATE', payload : {cartInfo : 0}});
  // });

}, []);

  return (
    <div className={`body-content ${pathname === '/' ? 'homepage' : 'subpage'} ${specialClassName}`}>
      <AppRouteChanged />
      <MenuLoader />
      <TopHeader></TopHeader>
      <div className="main-content">
        <div className="app-content">
          <Switch>
            <Route path="/ver" children={<AppVersionPage />} />
            <Route path="/cms/page/render/:id" children={<EditPage />} />

            {/* <Route path="/blog/:id" children={<BlogView />} /> */}

            {/* Protected member routes by memberType */}
            {/* <ProtectedRoute
              path="/members/entered-apprentice"
              component={ViewPage}
              requiredTypes={1}
              fallbackPath="/"
            />
            <ProtectedRoute
              path="/members/fellow-craft"
              component={ViewPage}
              requiredTypes={2}
              fallbackPath="/"
            />
            <ProtectedRoute
              path="/members/master-mason"
              component={ViewPage}
              requiredTypes={3}
              fallbackPath="/"
            />
            <ProtectedRoute
              path="/members/rose-croix"
              component={ViewPage}
              requiredTypes={18}
              fallbackPath="/"
            />
            <ProtectedRoute
              path="/members/knights-kadosh"
              component={ViewPage}
              requiredTypes={30}
              fallbackPath="/"
            />
            <ProtectedRoute
              path="/members/tribunal-of-courage"
              component={ViewPage}
              requiredTypes={31}
              fallbackPath="/"
            />
            <ProtectedRoute
              path="/members/consistory"
              component={ViewPage}
              requiredTypes={32}
              fallbackPath="/"
            />
            <ProtectedRoute
              path="/members/baringa-triangle"
              component={ViewPage}
              requiredTypes={33}
              fallbackPath="/"
            /> */}

            {/* Member Protected Routes */}
            <MemberProtectedRoute
              path="/members/entered-apprentice"
              component={ViewPage}
              requiredTypes={1}
            />
            <MemberProtectedRoute
              path="/members/fellow-craft"
              component={ViewPage}
              requiredTypes={2}
            />
            <MemberProtectedRoute
              path="/members/master-mason"
              component={ViewPage}
              requiredTypes={3}
            />
            <MemberProtectedRoute
              path="/members/rose-croix"
              component={ViewPage}
              requiredTypes={18}
            />
            <MemberProtectedRoute
              path="/members/knights-kadosh"
              component={ViewPage}
              requiredTypes={30}
            />
            <MemberProtectedRoute
              path="/members/tribunal-of-courage"
              component={ViewPage}
              requiredTypes={31}
            />
            <MemberProtectedRoute
              path="/members/consistory"
              component={ViewPage}
              requiredTypes={32}
            />
            <MemberProtectedRoute
              path="/members/baringa-triangle"
              component={ViewPage}
              requiredTypes={33}
            />

            <Route path="/login" children={<UnifiedLogin />} />
            {/* Unified Dashboard - Protected */}
            <DashboardProtectedRoute path="/dashboard" exact />
            
            {/* Profile - Protected */}
            <ProfileProtectedRoute path="/profile" exact />
            
            {/* Admins */}
            <Route path="/freemasonry/dashboard" children={<AdminsLayout />} />

            <AdminProtectedRoute
              path="/freemasonry/victoria-403"
              component={ViewPage}
              requiredRoles={["victoria 403"]}
              fallbackPath="/login"
            />

            <AdminProtectedRoute
              path="/freemasonry/treasurers"
              component={ViewPage}
              requiredRoles={["treasurers"]}
              fallbackPath="/login"
            />

            <AdminProtectedRoute
              path="/freemasonry/secretaries"
              component={ViewPage}
              requiredRoles={["secretaries"]}
              fallbackPath="/login"
            />

            <AdminProtectedRoute
              path="/freemasonry/national"
              component={ViewPage}
              requiredRoles={["national"]}
              fallbackPath="/login"
            />

            <AdminProtectedRoute
              path="/freemasonry/sydney-404"
              component={ViewPage}
              requiredRoles={["sydney 404"]}
              fallbackPath="/login"
            />

            <AdminProtectedRoute
              path="/freemasonry/ouroboros-2175"
              component={ViewPage}
              requiredRoles={["ouroboros 2175"]}
              fallbackPath="/login"
            />

            <AdminProtectedRoute
              path="/freemasonry/avalon-1718"
              component={ViewPage}
              requiredRoles={["avalon 1718"]}
              fallbackPath="/login"
            />

            <AdminProtectedRoute
              path="/freemasonry/aurora-australis-431"
              component={ViewPage}
              requiredRoles={["aurora australis 431"]}
              fallbackPath="/login"
            />

            <AdminProtectedRoute
              path="/freemasonry/adelaide-406"
              component={ViewPage}
              requiredRoles={["adelaide 406"]}
              fallbackPath="/login"
            />

            {/* For AUTH */}
            <Route path="/auth" children = {<SiteAuthLayout />}/>
            {/* <Route path='/member' component={MemberLayout} /> */}

            {/* <Route path="/admin">
              <Redirect to="/admin" />
            </Route> */}

            {/* For ECM <Route path="/order-thankyou" children = {<OrderDetails />}/>
            <Route path="/product/:slug" children = {<ProductView />}/> */}

            <Route path="/">
              <ViewPage />
            </Route>
            
            {/* Catch-all route for other pages (excluding members and dashboard) */}
            <Route path="/:path*" render={({ match }) => {
              // Don't render ViewPage for member routes as they're handled by ProtectedRoute
              if (match.params.path && match.params.path.startsWith('members/')) {
                return "Not Found";
              }
              // Don't render ViewPage for dashboard as it's handled by DashboardProtectedRoute
              if (match.params.path === 'dashboard') {
                return "Not Found";
              }
              return <ViewPage />;
            }} />
          </Switch>
        </div>
        {/* <app-common-bottom-partial></app-common-bottom-partial> */}
      </div>
      {/* <Footer></Footer> */}
      <BottomDock></BottomDock>
      <MediaQueryStatus />
      <CommonVideoPopup />
    </div>
  );
}

function App() {
  return (
    <StoreProvider>
      <HelmetProvider>
        <ProvideAuth>
          <Router>
            <AppLayout />
          </Router>
        </ProvideAuth>
      </HelmetProvider>
    </StoreProvider>
  );
}

export default App;
